import cover from '@/assets/img/cover.png';

import * as S from './style.ts';

interface PublicationJournalGuideProps {}

const PublicationJournalGuide: React.FC<PublicationJournalGuideProps> = (props) => (
	<S.Container>
		<S.ContentBox className="center">
			<S.ImgBox>
				<img src={cover} alt="대한화장품학회지 표지" />
			</S.ImgBox>
			<S.ContentItems>
				<S.ContentDescription>
					본 학회의 학술지인 대한화장품학회지는 1968년 학회의 설립 후 <strong>1970년 대한화장품학회지 1권이 발간</strong>되었다.
				</S.ContentDescription>
				<S.ContentDescription>
					1970년 4월 대한화장품학회지 1권 1호인 창간호에서 4편의 논문으로 시작하여, 현재는 1년에 4회 발행(3월, 6월, 9월, 12월)되며 게재 논문 수도 40여 편으로
					확대되어 학회의 발전과 함께 학회지의 질적 양적 변화가 괄목할 만한 수준에 이르렀다.
				</S.ContentDescription>
				<S.ContentDescription>
					또한 학회 회원의 증가와 편집위원들의 노력으로 <strong>국제표준연속간행물번호(ISSN) &quot;1226-2587&quot;</strong>를 배정받았고, 2007년 1월 1일에는
					학술진흥재단에 <strong>등재후보학술지로 선정</strong>된 후 <strong>2015년 1월 1일에 대한화장품학회지가 KCI등재학술지</strong>로 변경되었다.
				</S.ContentDescription>
				<S.ContentDescription>
					- 2015년 KCI등재 학술지
					<br />- 2018년 KCI등재 학술지 (유지)
					<br />- 2021년 KCI등재 학술지 (재인증)
					<br />
					학회 편집위원회 및 사무국에서는 KCI등재학술지 유지를 위해서 노력하고 있다.
				</S.ContentDescription>
				<S.ContentDescription>
					회원들의 많은 훌륭한 논문의 게재는 물론, 다른 학술잡지들에 자주 인용이 되어 궁극적으로 화장품 관련분야에서 세계 우수 학술지로 거듭나리라 예상된다.
				</S.ContentDescription>
			</S.ContentItems>
		</S.ContentBox>
	</S.Container>
);

export default PublicationJournalGuide;
